(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["unaluna-product-information"] && !Shopify.designMode) return;
  try {
    (() => {
  const createTickerIcon = (name) => {
    const paths = {
      parcel: 'M21 8 12 3 3 8v9l9 5 9-5V8ZM3 8l9 5 9-5M12 13v9M7.5 5.5l9 5',
      delivery: 'M1 3h14v13H1V3ZM15 8h4l3 4v4h-7M5 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM18 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4',
      returns: 'M3 10h11a7 7 0 0 1 0 14M3 10l5-5M3 10l5 5',
      pause: 'M9 5v14M15 5v14',
      play: 'm8 5 11 7-11 7V5Z'
    };
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', name === 'returns' ? '0 0 24 28' : '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.6');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', paths[name]);
    svg.append(path);
    return svg;
  };
  const placeBadges = () => {
    document.querySelectorAll('.product__info-container').forEach((info) => {
      const price = info.querySelector('[id^="price-"]');
      const badges = info.querySelector('[id="aca67e0c-2756-4544-bf60-19d314a23fcb"]');
      if (!price || !badges) return;
      badges.classList.add('ul-material-badges');
      const overview = info.querySelector('.ul-product-overview');
      const badgeAnchor = overview || price;
      if (badgeAnchor.nextElementSibling !== badges) badgeAnchor.after(badges);
    });
  };

  const placeShippingTicker = () => {
    document.querySelectorAll('.product__info-container').forEach((info) => {
      const source = info.querySelector('[id="8787c6e5-9bbb-409c-84f4-e1e40a81a016"]');
      if (!source) return;
      let ticker = info.querySelector('.ul-shipping-ticker');
      if (!ticker) {
        const shippingOffer = info.querySelector('.ul-product-information')?.dataset.shippingOffer;
        const messages = Array.from(source.querySelectorAll('.tooltip-container')).map((item) =>
          Array.from(item.querySelectorAll('span')).map((span) => span.textContent.trim()).filter(Boolean).join(' ')
        ).filter(Boolean).map((message) => shippingOffer && /fri fragt|free shipping/i.test(message) ? shippingOffer : message);
        if (!messages.length) return;
        ticker = document.createElement('div');
        ticker.className = 'ul-shipping-ticker';
        const viewport = document.createElement('div');
        viewport.className = 'ul-shipping-ticker__window';
        const track = document.createElement('div');
        track.className = 'ul-shipping-ticker__track';
        const group = document.createElement('div');
        group.className = 'ul-shipping-ticker__group';
        messages.forEach((message) => {
          const item = document.createElement('span');
          item.className = 'ul-shipping-ticker__item';
          const icon = document.createElement('span');
          icon.className = 'ul-shipping-ticker__icon';
          const iconName = /retur|return|fortryd/i.test(message) ? 'returns' : /lever|delivery|hurtig/i.test(message) ? 'delivery' : 'parcel';
          icon.append(createTickerIcon(iconName));
          const label = document.createElement('span');
          label.className = 'ul-shipping-ticker__label';
          label.textContent = message;
          item.append(icon, label);
          group.append(item);
        });
        const duplicate = group.cloneNode(true);
        duplicate.setAttribute('aria-hidden', 'true');
        track.append(group, duplicate);
        viewport.append(track);
        const control = document.createElement('button');
        control.type = 'button';
        control.className = 'ul-shipping-ticker__pause';
        control.append(createTickerIcon('pause'));
        const labels = info.querySelector('.ul-product-information').dataset;
        control.setAttribute('aria-label', labels.pauseLabel);
        control.setAttribute('aria-pressed', 'false');
        control.addEventListener('click', () => {
          const paused = ticker.classList.toggle('is-paused');
          control.replaceChildren(createTickerIcon(paused ? 'play' : 'pause'));
          control.setAttribute('aria-pressed', String(paused));
          control.setAttribute('aria-label', paused ? labels.playLabel : labels.pauseLabel);
        });
        ticker.append(viewport, control);
      }
      const buttons = info.querySelector('.product-form__buttons');
      const bundleButton = info.querySelector('.gbbPbAddToCartBtn');
      const bundleAnchor = bundleButton && bundleButton.getClientRects().length ? bundleButton.closest('.gbbPbAddToCart') : null;
      const fixedShipping = info.querySelector('.ul-purchase-shipping');
      const anchor = bundleAnchor || fixedShipping || (buttons && buttons.getClientRects().length && getComputedStyle(buttons).display !== 'none' ? buttons : source);
      if (anchor.nextElementSibling !== ticker) anchor.after(ticker);
      source.classList.add('ul-shipping-source');
    });
  };

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; placeBadges(); placeShippingTicker(); });
  });
  const start = () => {
    placeBadges();
    placeShippingTicker();
    const main = document.querySelector('main');
    if (main) observer.observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["unaluna-trust-line"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('unaluna-purchase-confidence')) {
  customElements.define('unaluna-purchase-confidence', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      const banner = this.querySelector('.ul-trust-banner');
      const pause = this.querySelector('.ul-trust-banner__pause');
      if (pause && banner) {
        pause.hidden = false;
        pause.addEventListener('click', () => {
          const paused = banner.classList.toggle('is-paused');
          pause.setAttribute('aria-pressed', String(paused));
          pause.setAttribute('aria-label', paused ? pause.dataset.playLabel : pause.dataset.pauseLabel);
        });
      }
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        if (target.tagName === 'DETAILS') target.open = true;
        target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        target.querySelector('summary')?.focus({preventScroll: true});
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
